import styled from "styled-components";
import { theme } from "styles/mui-config";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  // margin-top: 20px;
  position: relative;
  & p {
    text-align: center;
    padding-top: 10px;
  }
  &::before {
    content: "";
    position: absolute;
    right: 50%;
    left: 50%;
    top: 0px;
    width: 100px;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
    transform: translate(50%);
  }
`;

export const StyledTypography = styled(Typography)`
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  margin-left: 46px !important;
  line-height: 27px !important;
  & > span {
    color: gray;
  }
  @media (max-width: 790px) {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-left: 0px !important;
  }
  @media (max-width: 500px) {
    margin-bottom: 0px !important;
    margin-left: 0px !important;
    font-size: 13px !important;
    & > span {
      font-size: 13px !important;
    }
  }
`;

export const StyledCardContentDetail = styled.div`
  display: flex;
  padding: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #80808038;
  // @media (max-width: 975px) {
  //   flex-direction: column;
  // }
  // @media (max-width: 900px) {
  //   flex-direction: row;
  // }
  @media (max-width: 790px) {
    flex-direction: column;
  }

  & > div {
    display: flex;
    // @media (max-width: 975px) {
    //   flex-direction: column;
    // }
    // @media (max-width: 900px) {
    //   flex-direction: row;
    // }
    @media (max-width: 790px) {
      flex-direction: column;
    }
  }
`;

export const StyledStatus = styled.div`
  display: flex;
  flex-direction: row !important;
  align-items: center;
  & > span {
    margin-right: 7px;
    color: #3f444c;
  }
  @media (max-width: 500px) {
    & > span {
      font-size: 13px !important;
    }
  }
`;

export const StyledIcondiv = styled.div`
  width: 32px;
  height: 32px;
  // background: red;
  border-radius: 100%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    font-size: 35px;
  }
`;

export const StyledCardContentDetailProduct = styled.div`
  display: flex;
  align-items: center;
  padding: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #80808038;
  & > img {
    width: 110px !important;
    height: 110px !important;
  }
  & > div {
    padding-right: 25px;
  }
  @media (max-width: 500px) {
    flex-direction: column;
    // align-items: start;
    & > div {
      padding-right: 0px;
      width: 100%;
    }
  }
`;

export const StyledTypographyProduct = styled(Typography)`
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  margin-left: 46px !important;
  line-height: 27px !important;
  display: flex !important;
  align-items: center !important;
  & > div {
    display: flex !important;
    align-items: center !important;
  }
  & > div > div {
    display: inline-block;
    width: 20px !important;
    height: 20px !important;
    border-radius: 100%;
    border: 1px solid #808080ab;
    margin-left: 5px;
  }
  & > span {
    color: gray;
    margin-left: 5px;
  }
  @media (max-width: 500px) {
    justify-content: space-between !important;
    margin-left: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
    font-size: 13px !important;
    & > span {
      font-size: 13px !important;
    }
  }
`;
